import React, {PureComponent} from 'react';
import {filter} from 'lodash';
import {SocialButtons, ContactsList} from '../index';

class GeneralContacts extends PureComponent {

  render() {
    const {contacts} = this.props;
    const sContacts = filter(contacts, {type: 'social'});
    const gContacts = filter(contacts, {type: 'general'});

    return (
      <div className="general-contacts">
        <h2>Geral</h2>
        <div className="contacts">
          <ContactsList contacts={gContacts}/>
        </div>
        <div className="social">
          <SocialButtons follow={sContacts}/>
        </div>
      </div>
    );
  }
}

GeneralContacts.propTypes = {};
GeneralContacts.defaultProps = {};

export default GeneralContacts;



// WEBPACK FOOTER //
// ./src/components/general-contacts/GeneralContacts.js